import { render, staticRenderFns } from "./ContactPreferenceComponent.vue?vue&type=template&id=86f55ed8"
import script from "./ContactPreferenceComponent.vue?vue&type=script&lang=ts"
export * from "./ContactPreferenceComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports